module.exports = __webpack_public_path__ + "static/media/play.9e8fbad5.svg";